// extracted by mini-css-extract-plugin
export default {"intro":"Intro_intro__Bv-d8"};